/**
 * DeviationLegend — 4-step color legend for the deviation heatmap.
 * Renders inline; stateless.
 */
export default function DeviationLegend({ toleranceMm = 25 }) {
  const stops = [
    { c: '#10b981', l: `<= ${Math.round(toleranceMm * 0.2)} mm`, w: 'Within 20% tol' },
    { c: '#eab308', l: `${Math.round(toleranceMm * 0.2)}–${Math.round(toleranceMm * 0.6)} mm`, w: '20–60%' },
    { c: '#f97316', l: `${Math.round(toleranceMm * 0.6)}–${toleranceMm} mm`, w: '60–100%' },
    { c: '#ef4444', l: `> ${toleranceMm} mm`, w: 'Out of tolerance' },
  ];
  return (
    <div className="flex flex-wrap items-center gap-3 text-[10px] uppercase tracking-wider opacity-80" data-testid="deviation-legend">
      <span className="opacity-60">Deviation:</span>
      {stops.map(s => (
        <span key={s.w} className="flex items-center gap-1" title={s.w}>
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: s.c }} />
          <span className="font-mono">{s.l}</span>
        </span>
      ))}
    </div>
  );
}
